import styled from '@emotion/styled'

import { Color } from '../../../../enums/color'
import { Spacing } from '../../../../enums/spacing'

export const DrawerHeaderWrapper = styled.header`
  display: flex;
  align-items: center;
  padding: ${Spacing.S12} ${Spacing.S24};
  border-bottom: 1px solid ${Color.Grey100};
`

export const CustomDrawerHeaderWrapper = styled.header`
  position: relative;
`

export const CustomHeaderCloseButton = styled.div`
  position: absolute;
  top: ${Spacing.S12};
  right: ${Spacing.S24};
  z-index: 1;
`

export const HeaderRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S4};
  margin-left: auto;
`
